import MapPlacesHalloween from "./MapPlacesHalloween";
import MapPlacesDefault from "./MapPlacesDefault";
import MapPlacesChristmas from "./MapPlacesChristmas";

export default function MapWithPlaces(props) {
    switch (process.env.NEXT_PUBLIC_THEME) {
        case 'halloween':
            return <MapPlacesHalloween {...props}/>
        case 'christmas':
            return <MapPlacesChristmas {...props}/>
        default:
            return <MapPlacesDefault {...props}/>
    }
}
